import { queueFont } from "../queueFont";

export function RoomsLoadingFullScreen() {
  return (
    <div
      className={`${queueFont} flex min-h-screen w-full items-center justify-center bg-white text-xl font-semibold text-[#334155]`}
    >
      Loading rooms…
    </div>
  );
}
